<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>
    <b-table striped hover small responsive id="tablereport"
      :items="sessions"
      :fields="sessionsFields"
      :filter="filter"
      :per-page="perPage"
      :current-page="currentPage"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      isGenerateDisabled: false,
      selectGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: new Date(),
      dateEnd: new Date(),
      filterOptions: {
        isFilterGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      },
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accounting_period_id: 0
      },
      sessions: [],
      sessionsFields: [
        {key: 'id', label: this.$i18n.t('Session ID'), sortable: true},
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'last_update_date', label: this.$i18n.t('End date'), sortable: true},
        {key: 'called_station_id', label: this.$i18n.t('Called station'), sortable: true},
        {key: 'calling_station_id', label: this.$i18n.t('Calling station'), sortable: true},
        {key: 'framed_ip', label: this.$i18n.t('IP address'), sortable: true},
        {key: 'framed_ip6', label: this.$i18n.t('IP-address v6'), sortable: true},
        {key: 'nas_port', label: this.$i18n.t('NAS port'), sortable: true},
        {key: 'acct_session_id', label: this.$i18n.t('NAS session ID'), sortable: true},
        {key: 'uname', label: this.$i18n.t('Login'), sortable: true},
        {key: 'nas_ip', label: 'NAS IP', sortable: true},
        {key: 'status', label: this.$i18n.t('Status'), sortable: true},
        {key: 'acct_inp_oct', label: this.$i18n.t('Incoming bytes'), sortable: true},
        {key: 'acct_inp_giga', label: this.$i18n.t('Incoming gigabytes'), sortable: true},
        {key: 'acct_out_oct', label: this.$i18n.t('Outgoing bytes'), sortable: true},
        {key: 'acct_out_giga', label: this.$i18n.t('Outgoing gigabytes'), sortable: true},
        {key: 'acct_sess_time', label: this.$i18n.t('Duration'), sortable: true},
        {key: 'acct_term_cause', label: this.$i18n.t('Termination cause'), sortable: true},
        {key: 'total_cost', label: this.$i18n.t('Total cost'), sortable: true},
        {key: 'sessionsFlags', label: this.$i18n.t('Telephony dialup/VPN flags'), sortable: true}
      ]
    }
  },
  methods: {
    async load () {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_SESSIONS', this.getStore).then(response => {
        this.sessions = this.$store.getters['Reports/SESSIONS']
        for (let el of this.sessions) {
          el.last_update_date = moment(Number(el.last_update_date) * 1000).format('YYYY-MM-DD hh:mm')
          switch (el.framed_protocol) {
            case 1:
              el.status = this.$i18n.t('Start')
              break
            case 2:
              el.status = this.$i18n.t('Stop')
              break
            case 3:
              el.status = this.$i18n.t('Updated')
              break
            default:
              el.status = this.$i18n.t('Unknown status')
              break
          }
          switch (el.flags) {
            case 1:
              el.sessionsFlags = this.$i18n.t('Ignore sessions time')
              break
            case 2:
              el.sessionsFlags = this.$i18n.t('Dropped')
              break
            case 4:
              el.sessionsFlags = this.$i18n.t('Zero charge')
              break
            case 8:
              el.sessionsFlags = this.$i18n.t('Isg sessions')
              break
            default:
              el.sessionsFlags = 'D'
              break
          }
        }
        this.loadDone()
      })
      this.totalRows = this.sessions.length
      this.$emit('input', this.totalRows)
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/other/sessions/main.vue